import { HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST } from "./heating-system-exchange-system-list";
export const HEATING_SYSTEM_EXCHANGE_ENERGY_SOURCE_KEY_LIST = [
    ...new Set(HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST.map((system) => system.energySourceKey)),
];
